import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import * as moment from 'moment';

@Component({
  selector: 'app-date-picker',
  templateUrl: './date-picker.component.html',
  styleUrls: ['./date-picker.component.scss'],
})
export class DatePickerComponent implements OnInit {
  @Input() minDate = null;
  @Input() maxDate = null;
  @Input() value: any = new Date();

  @Output() onChangeEvent = new EventEmitter<string>();

  constructor() {}

  ngOnInit(): void {}

  onChange(value: string) {
      this.onChangeEvent.emit(value);
  }
}
